/**
 * Ryan O'Dowd
 * 2022-04-01
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, isDarkMode, safeAreaInsets}) => {
  return {
    innerContainer: {
      flex: 1,
      marginBottom: safeAreaInsets.bottom,
    },
    formSection: {
      display: 'flex',
      flexShrink: 1,
      paddingTop: 8,
      paddingRight: 16,
      paddingBottom: 4,
      paddingLeft: 16,
    },
    noteWrapper: {
      display: 'flex',
      padding: globalScale * 8,
      backgroundColor: colors.accent,
      borderRadius: globalScale * 12,
      marginBottom: 8,
    },
    noteText: {
      flex: 1,
      color: colors.primaryExtraDark,
      fontSize: globalScale * 16,
    },
    formSectionInner: {
      paddingTop: 4,
      paddingRight: 16,
      paddingBottom: 8,
      paddingLeft: 16,
    },
    titleTextInput: {
      fontSize: globalScale * 16,
      color: colors.white,
    },
    sectionHeaderText: {
      color: colors.white,
      fontSize: globalScale * 18,
      fontFamily: fonts.primaryBold,
    },
    addPassageButtonContent: {
      margin: -4,
      marginRight: -12,
      marginLeft: -8,
    },
    addPassageButtonText: {
      fontSize: globalScale * 12,
    },
    submitButton: {
      marginTop: 16,
    },

    passageContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: 4,
      marginBottom: 4,
    },
    dragWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 8,
    },
    dragIcon: {
      fontSize: globalScale * 22,
      color: colors.lightGray,
    },
    passageWrapper: {
      flex: 1,
      padding: globalScale * 6, // @TODO: confirm this looks good on web and native
      borderRadius: globalScale * 8, // @TODO: confirm this looks good on web and native
      borderWidth: 1,
      borderColor: colors.accent,
      backgroundColor: isDarkMode ? colors.primaryExtraDark : colors.primary,
      borderStyle: 'dashed',
    },
    actionsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      position: 'absolute',
      top: 0,
      right: 0,
    },
    row: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-end',
    },
    metadata: {
      color: colors.white,
      opacity: 0.5,
      fontSize: globalScale * 12,
    },
    passageText: {
      color: colors.white,
      padding: globalScale * 0, // @TODO: why doesn't this work?
      margin: globalScale * 0,
      fontSize: globalScale * 18,
    },
    translationText: {
      color: colors.white,
      opacity: 0.5,
      fontSize: globalScale * 14,
      marginLeft: globalScale * 4,
    },
    titleAndButton: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginRight: 16,
    },
    passagesFormSection: {
      flexGrow: 1,
    },
    passagesFormSectionInner: {
      flexGrow: 1,
      flexShrink: 1,
      justifyContent: 'flex-start',
      height: '10%', // @TODO: not sure why this works, but as long as the percentage is less than the whatever would calculate to be actual height, `flexGrow: 1` takes over to give desired results
    },
    list: {
      width: '100%',
    },
    updateDisabledText: {
      display: 'flex',
      textAlign: 'center',
      fontSize: globalScale * 14,
      color: colors.white,
      marginTop: globalScale * 4,
      marginBottom: globalScale * 16,
    },
    archiveText: {
      color: isDarkMode ? colors.white : colors.black,
    },
    deleteText: {
      color: colors.alert,
    },
  };
};

export default getStyles;
